<template>
  <b-form @submit="onSubmit" :class="'h-100 d-flex'">
    <b-form-row class="w-100 mx-0">
      <b-col cols="12" sm="4" class="px-0">
        <overlay-scrollbars :options="{ scrollbars: { autoHide: false }, overflowBehavior: { y: 'scroll', x: 'hidden' }, className : 'os-theme-dark os-theme-gekko' }">
          <div class="modal-form-legend">
            <legend v-translate>Basic cost data</legend>
          </div>
          <b-form-group id="input-group-4" label-class="gk-label-margin gk-modal-label" :label="$gettext('Description')" label-for="input-4">
            <b-form-input data-analytics-click id="input-4" v-model="cost.description" :placeholder="$gettext('Lunch, new laptop, business cards')"></b-form-input>
          </b-form-group>       
          <b-form-group v-if="showField('amount')" id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
            <template slot="label">
              {{ $gettext('Total (inc. VAT)') }} <span v-if="showAIfieldsAmount" class='ai-icon'>Ai</span>
            </template>
            <b-input-group>
              <b-form-input id="input-5" type="number" v-model="cost.amount" placeholder="0.0" step="0.01"></b-form-input>
            </b-input-group>
          </b-form-group>
          <b-form-group v-if="showField('subtotal_amount')" id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
            <template slot="label">
              {{ $gettext('Total (ex. VAT)') }} <span v-if="showAIfieldsAmount" class='ai-icon'>Ai</span>
            </template>
            <b-input-group>
              <b-form-input id="input-5" type="number" v-model="cost.subtotal_amount" placeholder="0.0" step="0.01"></b-form-input>
            </b-input-group>
          </b-form-group>

          <b-form-row>
            <b-col v-for="a_cost_line, index in cost.cost_lines" :key="'taxrate-' + index" cols="12"
                :lg="(cost.cost_lines.length % 2 != 0 && (index == (cost.cost_lines.length - 1))) ? 12 : 6">
              <b-form-group id="input-group-7" class="vat-input-size" label-class="gk-label-margin gk-modal-label" label-for="input-7">
                <template slot="label">
                  {{ $gettext('VAT') + ' ' + a_cost_line.tax_rate + '%' }} <span v-if="showAIfieldsVAT" class='ai-icon'>Ai</span>
                </template>
                <b-input-group>
                  <template #append>
                    <b-input-group-text class="btn" @click="calculate(a_cost_line)" :disabled="disableTaxFields()">
                      <b-icon icon="calculator" />
                    </b-input-group-text>
                  </template>
                    <b-form-input id="input-7" type="number" v-model="a_cost_line.amount" placeholder="0.0" step="0.01" :disabled="disableTaxFields()"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col cols="12" lg="6">
              <b-form-group v-if="showField('retention')" id="input-group-6" label-class="gk-label-margin gk-modal-label" :label="$gettext('Retention')" label-for="input-6">
                <b-input-group append="%">
                  <b-form-input data-analytics-click id="input-6" type="number" v-model="cost.retention_tax_percentage" :placeholder="$gettext('15.0%')" step="0.01" :disabled="disableTaxFields()"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
            <b-col cols="12" lg="6">
              <b-form-group v-if="showField('retention')" id="input-group-6" label-class="gk-label-margin gk-modal-label" :label="$gettext('Amount')" label-for="input-6">
                <b-input-group>
                  <template #append>
                    <b-input-group-text class="btn" @click="calculateRetentionAmount" :disabled="disableTaxFields()">
                      <b-icon icon="calculator" />
                    </b-input-group-text>
                  </template>
                  <b-form-input id="input-6" type="number" v-model="cost.retention_tax_amount" placeholder="0.0" step="0.01" :disabled="disableTaxFields()"></b-form-input>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-form-row>
          
          <b-form-group id="input-group-8" label-class="gk-label-margin gk-modal-label">
            <b-form-checkbox id="input-8" class="checkbox-bg-color" v-model="cost.tax_exempt" :disabled="cost.btw_reversed_charge" switch>
              <span class="font-80" v-translate>Exempt from tax</span>&nbsp;
              <span v-b-tooltip.hover :title="$gettext('Indicates that no VAT/sales tax will be paid on this cost item.')">
                <font-awesome-icon icon="fa-regular fa-circle-question" class="font-80 tooltip-icon tooltip-icon--question" />
              </span>
            </b-form-checkbox>

            <b-form-checkbox id="input-9" class="checkbox-bg-color" v-model="cost.btw_reversed_charge" :disabled="cost.tax_exempt" switch>
              <span class="font-80" v-translate>Reversed charge</span>&nbsp;
              <span v-b-tooltip.hover :title="$gettext('Indicates that no VAT/sales tax has been paid yet on this item. The buyer is responsible to account and report unpaid VAT/sales tax.')">
                <font-awesome-icon icon="fa-regular fa-circle-question" class="font-80 tooltip-icon tooltip-icon--question" />
              </span>
            </b-form-checkbox>
          </b-form-group>
            
          <b-form-row>
            <b-col cols="12" :lg="(!transactionCost) ? 6 : 12">
              <b-form-group id="input-group-6" label-class="gk-label-margin gk-modal-label" :label="$gettext('Cost type*')" label-for="input-6">
                <CostTypeSelector v-model="cost.cost_type" @change="onCostTypeChange"></CostTypeSelector>
                <template #description>
                  <GekkoButton 
                    @click="redirectCostTypes" 
                    :text="$gettext('Add cost categories')" 
                    icon="fa-solid fa-plus" 
                    class="p-0 whitesp-normal"
                    size="sm"
                    variant="link"
                  />
                </template>
              </b-form-group>
            </b-col>
          </b-form-row>
          
          <div v-if="!showExtraFields" class="p-3" style="border-top: 1px solid rgba(0, 0, 0, 0.1);">
            <GekkoButton 
              @click="showExtraFields = true" 
              :text="$gettext('Show all fields')" 
              icon="fa-solid fa-chevron-down" 
              class="w-100 text-info whitesp-normal"
              variant="link"
            />
          </div>
          
          <div v-show="showExtraFields">
            <b-form-row>
              <b-col cols="12" lg="6">
                  <b-form-group id="input-group-1" label-class="gk-label-margin gk-modal-label" label-for="input-1">
                      <template slot="label">
                          {{ $gettext('Cost date') }} <span v-if="showAIfieldsDate" class='ai-icon'>Ai</span>
                      </template>
                      <b-form-datepicker id="input-1" v-model="cost.date" no-flip initial-date="2021-01-01"
                                          :date-format-options="{ year: 'numeric', month: 'short', day: 'numeric' }"></b-form-datepicker>
                  </b-form-group>
              </b-col>
              <b-col cols="12" lg="6">
                  <b-form-group id="input-group-2" label-class="gk-label-margin gk-modal-label"
                                  :label="$gettext('Cost number*')" label-for="input-2">
                      <b-form-input data-analytics-click id="input-2" v-model="cost.number" required
                                      :placeholder="$gettext('2020-000001')" @input="costNumberChange"></b-form-input>
                  </b-form-group>
              </b-col>
            </b-form-row>

            <b-form-group v-if="showField('number_on_document')" id="input-group-3" label-class="gk-label-margin gk-modal-label"
                            :label="$gettext('Number on document')" label-for="input-3">
                <b-form-input data-analytics-click id="input-3" v-model="cost.number_on_document"></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-5" label-class="gk-label-margin gk-modal-label" label-for="input-5">
                <template slot="label">
                    {{ $gettext('Supplier') }} <span v-if="showAIfieldsSupplier" class='ai-icon'>Ai</span>
                </template>
                <b-form-group>
                    <CustomerSelector v-model="cost.supplier" :filters="{is_supplier:'True', owner_company:cost.owner_company, is_archived:'False'}"></CustomerSelector>
                </b-form-group>
            </b-form-group>


            <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Payment type')" label-for="input-10">
              <PaymentTypeSelector v-model="cost.payment_type"></PaymentTypeSelector>
            </b-form-group>

            <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Customer')" label-for="input-10">
                <b-form-group>
                    <CustomerSelector v-model="cost.customer" @change="customerCallback"
                                        :filters="{is_customer:'True', owner_company:cost.owner_company, is_archived:'False'}">
                    </CustomerSelector>
                </b-form-group>
            </b-form-group>
            <b-form-group id="input-group-10" label-class="gk-label-margin gk-modal-label" :label="$gettext('Project')" label-for="input-10">
                <b-form-select v-model="cost.project" :disabled="projectList.length===0">
                    <b-form-select-option v-for="project in projectList" :value="project.id" :key="project.id">
                        {{project.name}}
                    </b-form-select-option>
                </b-form-select>
            </b-form-group>

          </div>

        </overlay-scrollbars>
      </b-col>
      <b-col cols="12" sm="8" class="modal-dropzone-actions pr-0">
        <div class="modal-dropzone-actions--wrap">
          <div class="modal-main-actions">
            <SmartScanSwitch @change="onSmartScanChange" />
            <div v-if="scanning || emptyScan" class="w-100">
              <ProgressBar v-if="scanning" class="w-50 ml-3" />
              <div class="hint" v-if="emptyScan">We could not find any data. Try again or upload a different file.</div>
            </div>
          </div>
          <div class="modal-dropzone-wrapper">
            <VueDropzone :preloaded_file="imageSrc" :allowed-files="'all'" :onlyChange="true" @change="fileChanged"></VueDropzone>
          </div>
        </div>
        <b-row class="cost-modal-actions">
          <b-col cols="12" sm="12" class="cost-complete-info-wrapper">
            <div class="cost-complete-info h-100" :class="costStatus">
              <b-row v-show="cost.payment_type=='notpaid'" class="h-100" align-v="center">
                <b-col cols="10" style="font-size: 13px;">
                  <b-container>
                    <font-awesome-icon aria-hidden="true" icon="fa-solid fa-triangle-exclamation" />
                    <span v-translate>This receipt is market as not yet paid.</span>
                  </b-container>
                </b-col>
              </b-row>
              <b-row v-show="!showmissingFields && cost.payment_type!='notpaid'" class="cost-info">
                <b-col cols="9" class="cost-info__msg">
                  <b-container class="cost-info__msg__container">
                    <font-awesome-icon aria-hidden="true" icon="fa-solid fa-triangle-exclamation" />
                    <div>
                      <span v-translate>Incomplete. The following fields are missing:</span>
                      <span v-for="field in isCostComplete()" :key="field">{{field}}</span>
                    </div>
                  </b-container>
                </b-col>
                <b-col cols="3" class="cost-info__btn">
                  <b-container>
                    <GekkoButton 
                      @click="toggleComplete" 
                      :text="$gettext('Ignore')" 
                      class="text-danger p-0"
                      variant="link" 
                    />
                  </b-container>
                </b-col>
              </b-row>
              <b-row v-show="showmissingFields && cost.payment_type!='notpaid'" class="cost-info">
                <b-col cols="9" class="cost-info__msg">
                  <b-container class="cost-info__msg__container">
                    <font-awesome-icon aria-hidden="true" icon="fa-regular fa-circle-check" />
                    <span v-translate>Complete</span>
                  </b-container>
                </b-col>
                <b-col cols="3" class="cost-info__btn">
                  <b-container>
                    <GekkoButton 
                      v-if="!allFieldsFilled" 
                      @click="toggleComplete" 
                      :text="$gettext('Undo')" 
                      class="text-danger p-0"
                      variant="link" 
                    />
                  </b-container>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
        <b-row class="bottom-actions">
          <b-col class="bottom-actions-btn-wrap">
            <div v-if="$route.name === 'EditCost' && (prevNext.prev || prevNext.next)" class="nav-btns px-2 mr-2">
              <div :class="{ 'nav-disabled': !prevNext.prev }" id="tooltip-status-prev">
                <GekkoButton 
                  v-if="!unsavedChanges" 
                  @click="navigateTo(prevNext.prev, false)" 
                  icon="fa-solid fa-arrow-left"
                  :text="$gettext('Previous')"
                  variant="link" 
                />
                <GekkoButton 
                  v-else 
                  @click="navigateTo(prevNext.prev, true)" 
                  icon="fa-solid fa-arrow-left"
                  :text="$gettext('Save and Previous')"
                  variant="link" 
                />
                <b-tooltip :disabled="(prevNext.prev) ? true : false" custom-class="nav-tooltip" target="tooltip-status-prev">{{ $gettext('No more results loaded. Please update filters to get more results.') }}</b-tooltip>
              </div>
              <div class="nav-separator">|</div>
              <div :class="{ 'nav-disabled': !prevNext.next }" id="tooltip-status-next">
                <GekkoButton 
                  v-if="!unsavedChanges" 
                  @click="navigateTo(prevNext.next, false)" 
                  icon="fa-solid fa-arrow-right"
                  :icon-right="true"
                  :text="$gettext('Next')"
                  variant="link" 
                />
                <GekkoButton 
                  v-else
                  @click="navigateTo(prevNext.next, true)" 
                  icon="fa-solid fa-arrow-right"
                  :icon-right="true"
                  :text="$gettext('Save and Next')"
                  variant="link" 
                />
                <b-tooltip :disabled="(prevNext.next) ? true : false" custom-class="nav-tooltip" target="tooltip-status-next">{{ $gettext('No more results loaded. Please update filters to get more results.') }}</b-tooltip>
              </div>
            </div>
            <GekkoButton 
              :text="$gettext('Save Cost')"
              icon="fa-regular fa-floppy-disk"
              type="submit"
              :disabled="isSaving"
              class="float-right"
            />
          </b-col>
        </b-row>
      </b-col>
    </b-form-row>
  </b-form>
</template>
<script>
  import EditCost from "@/components/costs/EditCost.vue";

  export default {
    name: "BankCreateCost",
    extends: EditCost,
    data () {
      return {
        showExtraFields: false
      }
    },
    methods: {
        
    }
  }
</script>
